import React, { useState } from "react";
import "./Header.css";
import { fallDown as Menu } from "react-burger-menu";

function Header() {
    const [open, setOpen] = useState(false);
    const handleStateChange = (state) => setOpen(state.isOpen);
    const closeMenu = () => setOpen(false);

    return (
        <header className="site-header" id="top">
            <div className="header-container">
                <a className="logo" href="#top" aria-label="Sevan home">
                    <img src="/logos/branding-07.png" alt="Sevan Space logo" />
                </a>

                {/* Desktop nav */}
                <nav className="main-nav" aria-label="Primary">
                    <ul>
                        <li><a href="#whats-on">What's On</a></li>
                        <li><a href="#booking-section">Bookings</a></li>
                        <li><a href="#about">About</a></li>
                    </ul>
                </nav>

                <div className="burger-wrap">
                    <Menu
                        right
                        isOpen={open}
                        onStateChange={handleStateChange}
                        pageWrapId="page-wrap"
                        outerContainerId="outer-container"
                    >
                        <a href="#whats-on" className="bm-item" onClick={closeMenu}>What's On</a>
                        <a href="#booking-section" className="bm-item" onClick={closeMenu}>Bookings</a>
                        <a href="#about" className="bm-item" onClick={closeMenu}>About</a>
                    </Menu>
                </div>
            </div>
        </header>
    );
}

export default Header;
